// File: CompanyHeader.jsx
import React from "react";

export default function CompanyHeader({ company, showLogo = true }) {
  if (!company) return null;

  return (
    <div style={{ marginBottom: "25px", width: "100%", direction: "rtl" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr", // ✅ 3 أعمدة: عربي - شعار - إنجليزي
          alignItems: "center",
          gap: "20px",
          width: "100%",
          direction: "rtl" // ✅ تأكيد الاتجاه
        }}
      >
        {/* 📌 يمين (عربي) */}
        <div style={{ textAlign: "right", fontSize: "14px", direction: "rtl" }}>
          <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
            {company.name}
          </div>
          <div>الرقم الضريبي: {company.taxNumber || "—"}</div>
          <div>العنوان: {company.address || "—"}</div>
          <div>الهاتف: {company.phone || "—"}</div>
        </div>

        {/* ✅ الشعار بالنص */}
        <div style={{ textAlign: "center", minWidth: "100px" }}>
          {showLogo && company.logoUrl && (
            <img
              src={company.logoUrl}
              alt="Company Logo"
              style={{
                maxWidth: "120px",
                maxHeight: "100px",
                objectFit: "contain",
              }}
              onError={(e) => (e.target.style.display = "none")}
            />
          )}
        </div>

        {/* 📌 يسار (English) */}
        <div style={{ textAlign: "left", fontSize: "14px", direction: "ltr" }}>
          <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
            {company.nameEn || ""}
          </div>
          <div>VAT No: {company.taxNumber || "—"}</div>
          <div>Address: {company.addressEn || company.address || "—"}</div>
          <div>Phone: {company.phone || "—"}</div>
        </div>
      </div>
    </div>
  );
}
